export default {
    breadcrumb: []
}